var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.35088 13.5C8.143 13.4993 7.94473 13.4124 7.80338 13.26L4.15838 9.38251C3.87464 9.08014 3.88975 8.605 4.19213 8.32127C4.4945 8.03753 4.96964 8.05264 5.25338 8.35502L8.34338 11.6475L14.6509 4.74752C14.8253 4.53033 15.1057 4.42769 15.3791 4.48097C15.6525 4.53425 15.8739 4.73467 15.954 5.00146C16.0341 5.26824 15.9597 5.55745 15.7609 5.75252L8.90588 13.2525C8.76584 13.4077 8.56739 13.4974 8.35838 13.5H8.35088Z",
    fill: "#CBCBCD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.38ae9cc36332358c9a2d7439abbf7b96.svg";
export { ForwardRef as ReactComponent };